import { environment } from 'environments/environment';

export const REGEX_STRONG_PASSWORD = /^(?=^.{8,}$)(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~])(?=.*[A-Z])(?=.*[a-z]).{8,}$/;
export const REGEX_PHONE_NUMBER = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
export const REGEX_EMAIL = /^[\w-.]+@([\w-]+\.)+[\w-]{2,9}$/;
export const REGEX_SPECIAL_CHARS = /^[^!@#%^&*()+=\$\[\]\{\}\|;:\"\/<>\?~`\r\t\n]*$/;

export const APIURL = `${environment.apiServer.protocol}://${environment.apiServer.domain}:${environment.apiServer.port}/`;

export const DEFAULT_COUNTRY_CODE = 'IT';

export enum CONFLICT_ERROR_PARAMS {
  EMAIL_ALREADY_EXISTS = 'EMAIL_ALREADY_EXISTS',
  VAT_NUMBER_ALREADY_USED = 'VAT_NUMBER_ALREADY_USED',
  ACTIVATION_CODE_NOT_FOUND = 'ACTIVATION_CODE_NOT_FOUND',
  USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
  IM_REGISTRATION_ERROR = 'IM_REGISTRATION_ERROR',
  SF_REGISTRATION_ERROR = 'SF_REGISTRATION_ERROR',
  OFFLINELICENSEKEYRESETLIMIT = 'OFFLINELICENSEKEYRESETLIMIT',
}

export enum ConfirmAction {
  CANCEL = 0,
  CONFIRM = 1,
  THIRD_ACTION = 2,
}

export enum HttpMethod {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  DELETE = 'delete',
}

export enum MessageType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warn',
  INFO = 'info',
  DISCONNECT = 'warn',
}

export enum StoreKey {
  PROFILE = 'profile',
  TOKEN = 'token',
  REFRESHTOKEN = 'refresh_token',
  DEVICEID = 'deviceId',
  CUSTOMERID = 'customerId',
}

export interface Header {
  name?: string;
  visibleName: string;
  sortable?: boolean;
  default?: boolean;
}

export const MIN_DATE_PICKER = new Date(1900, 0, 1, 0, 0, 0, 0);

export const ACTIVATION_CODE_RETRY_TIME = 60; // Default retry time for activation code in seconds
